import { Http, SessionStore } from '@mezha/api'
import { platform } from '../platform/detect'

/** The one HTTP client of the game. VITE_API_URL is the server root
 *  without /api; empty means the same origin (the dev proxy). Signing out is
 *  observed through `session.subscribe` (app/store.ts). */
export const session = new SessionStore(platform() === 'vk' ? 'mezha.refresh.vk' : 'mezha.refresh')

export const http = new Http({ baseUrl: import.meta.env.VITE_API_URL ?? '', session })
